import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useParams } from 'react-router-dom-v5-compat';
import { UserKey } from '../domain';

const maybeSerialize =
  (readable: boolean) =>
  (value: string): string =>
    readable ? value : encodeURIComponent(value);

export const useUserKeyParameter = (readable: boolean = false): UserKey => {
  const { userKey } = useParams();

  return pipe(
    userKey,
    option.fromNullable,
    option.map(decodeURIComponent), // decode if we have a non-empty value
    option.map(maybeSerialize(readable)), // re-encode if requested
    option.getOrElse(() => ''), // fallback to an empty string
  );
};
